import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MultiSample from '~/cards/components/common/Samples/MultiSample/MultiSample';
import { setMultiSampleEnabled } from '~/cards/actions/samples';
import { getSearchFilters } from '~/cards/selectors/cardCatalogSelector';
import { SUPPORTED_CARD_TYPES as supportedSamplesCardTypes } from '~/cards/components/common/Samples/constants';
import { FreeSamplesContainer, LabelContainer } from './FreeSamples.style';

export const ToggleLabel = () => {
  return <LabelContainer>Pick free samples</LabelContainer>;
};

interface FreeSamplesProps {
  className?: string;
  scrollToTop?: () => void;
}

export const FreeSamples = ({ className, scrollToTop }: FreeSamplesProps) => {
  const dispatch = useDispatch();
  const searchFilters = useSelector(getSearchFilters);
  const { digital_suite: isDigital, lead_card_type: cardType } = searchFilters;
  const allowMultiSample = supportedSamplesCardTypes.includes(cardType) && !isDigital;

  useEffect(() => {
    if (allowMultiSample) {
      // setMultiSampleEnabled will return available free samples
      dispatch(setMultiSampleEnabled(cardType));
    }
  }, [allowMultiSample, dispatch, cardType]);

  if (!allowMultiSample) return null;

  return (
    <FreeSamplesContainer className={className}>
      <ToggleLabel />
      <MultiSample.Toggle cardType={cardType} scrollToTop={scrollToTop} />
    </FreeSamplesContainer>
  );
};
